import React from 'react';
import css from './style.scss';
import propstreamAccountLogo from
  'assets/images/account-page/propstreamlogo-account.svg';

const AccountLogo = () => (
  <span className={css.reviewLogoWrapper}>
    <img
      src={propstreamAccountLogo}
      alt="PropStream Logo"
      className={css.reviewLogo}
    />
  </span>
);

export default AccountLogo;